import type { Location } from '../types';
export const parsePlaceDetails = (
  placeDetails: google.maps.places.PlaceResult | null,
): Location => {
  const location: Location = {};

  placeDetails?.address_components?.forEach((detail) => {
    const types = new Set(detail.types);

    if (types.has('postal_code')) {
      location.postalCode = detail.long_name;
    }
    if (types.has('street_number')) {
      location.number = detail.long_name;
    }
    if (types.has('locality')) {
      location.city = detail.long_name;
    }
    if (types.has('route') || types.has('street_address')) {
      location.street = detail.long_name;
    }
  });

  return location;
};
